import React from 'react';
import WeatherData from './WeatherData';

function App() {
  return <WeatherData />;
}

export default App;
